import React from 'react'

import { withFirestore } from 'react-firestore'
import MsgNetLoading from '../components/MsgNetLoading'
import CompeticionList from '../components/CompeticionList'
import SharePanel from '../components/SharePanel'
import TopHeaderMenu from '../components/TopHeaderMenu'
import IconMap from '../icons/IconMap'
import CONFIG from '../config'

class EventoDetailScreen extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      competiciones: [],
      isLoading: true,
      evento: null,
      rankings: {},
      showSharePanel: false
    }
  }

  toogleSharePanel () {
    this.setState(state => ({
      showSharePanel: !this.state.showSharePanel
    }))
  }

  onClickBack () {
    this.props.history.push('/')
  }

  componentDidMount () {
    const { firestore } = this.props
    const eventoId = parseInt(this.props.match.params.eventoId, 10)

    firestore.doc('evento/' + eventoId).onSnapshot(snapshot => {
      let evento = snapshot ? snapshot.data() : null
      if (evento) {
        evento.id = snapshot.id
      }
      this.setState({ evento })
    })

    firestore.collection('competicion/')
      .where('evento_id', '==', eventoId)
      .where('visible', '==', true)
      // .orderBy('guntime', 'asc')
      .onSnapshot((snapshot) => {
        let competiciones = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }))
        competiciones.sort((a, b) => {
          // console.info(a.fecha_inicio)
          // console.info(a.hora_inicio)
          return a.hora_inicio - b.hora_inicio
        })
        this.setState({
          competiciones: competiciones,
          isLoading: false
        })
      })
  }

  // ...
  render () {
    const evento = this.state.evento

    return (
      <div>
        <TopHeaderMenu
          competicion={evento}
          onClickBack={this.onClickBack.bind(this)}
          onClickShare={this.toogleSharePanel.bind(this)}
        />

        {this.state.isLoading ? (
          <MsgNetLoading />
        ) : (
          (evento && evento.visible) ? (
            (this.state.competiciones && this.state.competiciones.length) ? (
              <div className={'container--padding'}>
                <CompeticionList competiciones={this.state.competiciones} />

                {evento.url_recorridos && (
                  <div style={{marginTop: '30px'}}>
                    <a href={evento.url_recorridos} style={botonRecorridosStyle} target={'blank'}>
                      Ver Recorridos <IconMap style={{verticalAlign: 'middle'}} />
                    </a>
                  </div>
                )}
              </div>
            ) : (
              <div className={'container--padding'}>
                <h3 className={'text-center'} style={{ marginTop: '50px' }}>
                  No existen competiciones activas
                </h3>
              </div>
            )
          ) : (
            <div>
              <br />
              <h2 className={'text-center'}>No se ha podido encontrar el evento especificado</h2>
            </div>
          )
        )}

        {this.state.showSharePanel && (
          <SharePanel
            close={this.toogleSharePanel.bind(this)}
            url={`/${evento.id}`}
            title={`Pruebas en vivo en el evento ${evento.nombre}`} />
        )}

      </div>
    )
  }
}

const botonRecorridosStyle = {
  color: 'white',
  backgroundColor: CONFIG.PRIMARY_COLOR,
  padding: '10px',
  display: 'table-cell'
}

export default withFirestore(EventoDetailScreen)



// WEBPACK FOOTER //
// ./src/containers/EventoDetailScreen.js